import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_maintenance_regular_inspection_laser_radiation_equipment'

export const dataPointDefinition = {
  retracedId: 'no_maintenance_regular_inspection_laser_radiation_equipment',
  name: 'No maintenance and/or regular inspection of laser/radiation equipment',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-wor-38x',
      number: 'HS-WOR-20-1',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-wor-37',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-32--1,Yes',
      machineShowHide: '[2],hs-32--1,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-38x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31800,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
